import { ConnectionAlerts } from "@station/domain/models/connection-alert.model";
import type { AlertRepository } from "@station/domain/repositories/alert.repository";
import { stationsTypes } from "@station/station-types.di.ts";
import { inject, injectable } from "inversify";

@injectable()
export class ConnectionAlertGetAllUseCase {
    constructor(
        @inject(stationsTypes.repositories.AlertRepository)
        private readonly alertRepository: AlertRepository,
    ) {}

    async execute(stationId: string): Promise<ConnectionAlerts> {
        const connectionAlertResult =
            await this.alertRepository.getAllConnectionAlert(stationId);

        if (connectionAlertResult.isErr()) {
            throw new Error("Error getting connection alerts");
        }

        return connectionAlertResult.match(
            (connectionAlerts) => connectionAlerts,
            () => ConnectionAlerts.empty(),
        );
    }
}
